import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-2 mb-1">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs text-foreground-500 font-label uppercase tracking-wider">Categories</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            吃瓜分类矩阵
          </h2>
          <p className="text-sm text-foreground-600 mt-2">按话题快速找到你最感兴趣的瓜</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="relative aspect-square rounded-lg overflow-hidden group cursor-pointer block"
            >
              <img
                src={cat.imageUrl}
                alt={cat.name}
                title={cat.name}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-4">
                <h3 className="text-xl md:text-2xl font-heading font-bold text-background-50 mb-1.5">
                  {cat.name}
                </h3>
                <p className="text-sm text-background-200 max-w-[200px]">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}